<div class="stadium-my-bets-bets-container">
    <div class="archived-bets-bottom" *ngIf="showArchivedBets">
        <div class="archived-bets" (click)="openArchivedBetsPopup()">{{ sitecore.betslip.archivedBetsHelpBox.Title }}</div>
    </div>
    <div class="transaction-bets-bottom" *ngIf="showTransactionBets">
        <div class="transaction-bets" (click)="openTransactionBetsPopup()">{{ sitecore.betslip.transactionBetsHelpBox.Title }}</div>
    </div>
</div>
